import { toast as baseToast } from 'react-toastify';
import React from 'react';
import classNameBind from 'classnames/bind';

import { ToastContent } from '../ToastContent';
import styles from '../Toast.module.css';

const bindClasses = classNameBind.bind(styles);

const updateToast = ({
  id,
  type,
  text,
  autoCloseSeconds = 0,
  actions = [],
  description = null,
}) => {
  baseToast.update(`toast-message-${id}`, {
    render: <ToastContent type={type} text={text} description={description} actions={actions} />,
    autoClose: autoCloseSeconds * 1000,
    className: bindClasses('toast', type),
    bodyClassName: bindClasses('toast-body'),
    pauseOnHover: false,
  });
};

export { updateToast };
